ShellController.$inject = ['ShellService']

export default function ShellController(ShellService) {
  var vm = this

  // ShellService.getUserSessionHistories().then(function(res) {
  //   vm.userSessionHistories = res.data
  // })
}